import { CoralText, IconWrapper } from 'components/common/Styled';
import StationIcon from 'components/common/StationIcon';
import { StationType } from 'pages/Map/types';
import { TourStep, TourType } from './types';
import { StationIconsWrapper } from './MapTour.styled';
import { ReactComponent as PathNotTraveledSelected } from '../../../../assets/svg/paths/not_traveled_selected.svg';
import { ReactComponent as PathTraveledSelected } from '../../../../assets/svg/paths/traveled_selected.svg';
import { GuidedTourStep } from 'components/common/GuidedTour/types';

export const MAP_SPECIFIC_TOUR_START_INDEX = 1;
export const tourSteps: (TourStep | GuidedTourStep)[] = [
    {
        header: 'Different types of zones',
        targetRef: {} as unknown as any,
        position: 'top',
        distance: 0,
        content: "Here's where you can find all the zones to your assigned map. Go ahead and click on any of the zones below to start!",
        targetScroll: () => {}
    },
    {
        title: 'Map Tour',
        content: (
            <>
                This is a <CoralText>map</CoralText> for your experience, tailored based on the information you provided.
            </>
        ),
        primaryBtnLabel: "Let's explore!",
        type: TourType.INITIAL_STEP
    },
    {
        title: 'Looking at the Map',
        content: (
            <>
                Click here to zoom in and out of the <CoralText>map</CoralText>, another option is to use two fingers on your track pad or
                on a touchscreen.
            </>
        ),
        type: TourType.ZOOM_IN_ZOOM_OUT
    },
    {
        title: 'Station and Drawers',
        content: (
            <>
                These are called <CoralText>stations</CoralText>, when you click on them a <CoralText>drawer</CoralText> will open. A{' '}
                <CoralText>drawer</CoralText> holds relevant information, resources, and recommended questions for your oncology team, for
                you to easily access during every part of your experience. Try it out, click any <CoralText>station!</CoralText>
            </>
        ),
        type: TourType.STATION_AND_DRAWERS
    },
    {
        title: 'Know your Stations',
        content: (
            <>
                Each station will have a symbol that distinguishes it. These are all the symbols:
                <StationIconsWrapper>
                    <IconWrapper>
                        <StationIcon type={StationType.ZoneStart} />
                    </IconWrapper>
                    <IconWrapper>
                        <StationIcon type={StationType.Decision} />
                    </IconWrapper>
                    <IconWrapper>
                        <StationIcon type={StationType.SubZone} />
                    </IconWrapper>
                    <IconWrapper>
                        <StationIcon type={StationType.ZoneEnd} />
                    </IconWrapper>
                    <IconWrapper>
                        <StationIcon type={StationType.Info} />
                    </IconWrapper>
                </StationIconsWrapper>
            </>
        ),
        type: TourType.INFO_ABOUT_STATIONS
    },
    {
        title: 'Legend and Map Info',
        content: (
            <>
                While you are using the <CoralText>map</CoralText>, if you ever forget the meaning of stations, you can find a{' '}
                <CoralText>legend</CoralText> here, and if you ever need clarification you can find more information in{' '}
                <CoralText>Map Info</CoralText>.
            </>
        ),
        type: TourType.INFO_ABOUT_LEGENEDS
    },
    {
        title: 'Mark a Path',
        content: (
            <>
                This is the start of the diagnosis zone. To begin, you can mark the path you are taking or planning to take in{' '}
                <PathTraveledSelected className="path-icon" /> yellow and mark the paths not being taken in{' '}
                <PathNotTraveledSelected className="path-icon" /> grey. Click on a path to change it&#39;s color. Don&#39;t worry, you can
                also always reset the <CoralText>path</CoralText>. Click the <CoralText>path</CoralText> here to try it out!
            </>
        ),
        type: TourType.INFO_ABOUT_PATHS
    },
    {
        title: 'Transition Zones',
        content: (
            <>
                Remember this station to transition smoothly between <CoralText>map zones.</CoralText> These <CoralText>zones</CoralText>{' '}
                indicate you&#39;re moving to a new <CoralText>zone</CoralText> (either diagnosis, treatment or survivorship). You can also
                use this navigator below to move through <CoralText>zones.</CoralText>
            </>
        ),
        type: TourType.TRANSITION_ZONE
    },
    {
        title: 'Timeline',
        content:
            "The left hand side of the map, is divided into sections. Each section provides an approximate time it will take to complete this section based on other people's experiences. However, we know there is no typical experience, therefore depending on your path it may vary.",
        type: TourType.PLAN_UR_LIFE
    }
];
